// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/comps/Footer/Footer.css
// module id = 534
// module chunks = 0